import api from "./api";

// SLA Policies
export const getSLAPolicies = (params) => api.get("/sla-policies", { params });
export const createSLAPolicy = (data) => api.post("/sla-policies", data);
export const updateSLAPolicy = (id, data) => api.put(`/sla-policies/${id}`, data);
export const deleteSLAPolicy = (id) => api.delete(`/sla-policies/${id}`);

// Auto-Assign Rules
export const getAutoAssignRules = () => api.get("/auto-assign-rules");
export const createAutoAssignRule = (data) => api.post("/auto-assign-rules", data);
export const updateAutoAssignRule = (id, data) => api.put(`/auto-assign-rules/${id}`, data);
export const deleteAutoAssignRule = (id) => api.delete(`/auto-assign-rules/${id}`);

// Deal Stages
export const getDealStages = () => api.get("/deal-stages");
export const createDealStage = (data) => api.post("/deal-stages", data);
export const updateDealStage = (id, data) => api.put(`/deal-stages/${id}`, data);
export const deleteDealStage = (id) => api.delete(`/deal-stages/${id}`);

// Deals
export const getDeals = (params) => api.get("/deals", { params });
export const createDeal = (data) => api.post("/deals", data);
export const updateDeal = (id, data) => api.put(`/deals/${id}`, data);
export const deleteDeal = (id) => api.delete(`/deals/${id}`);

// Ticket Custom Fields
export const getTicketCustomFields = () => api.get("/ticket-custom-fields");
export const createTicketCustomField = (data) => api.post("/ticket-custom-fields", data);
export const updateTicketCustomField = (id, data) => api.put(`/ticket-custom-fields/${id}`, data);
export const deleteTicketCustomField = (id) => api.delete(`/ticket-custom-fields/${id}`);
export const saveTicketCustomFieldValues = (ticketId, values) => api.post(`/ticket-custom-fields/values/${ticketId}`, { values });
export const getTicketCustomFieldValues = (ticketId) => api.get(`/ticket-custom-fields/values/${ticketId}`);

// WhatsApp Templates
export const getWhatsappTemplates = (params) => api.get("/whatsapp-templates", { params });
export const createWhatsappTemplate = (data) => api.post("/whatsapp-templates", data);
export const updateWhatsappTemplate = (id, data) => api.put(`/whatsapp-templates/${id}`, data);
export const deleteWhatsappTemplate = (id) => api.delete(`/whatsapp-templates/${id}`);

// Audit Logs
export const getAuditLogs = (params) => api.get("/audit-logs", { params });
export const exportAuditLogs = (params) => api.get("/audit-logs/export", { params, responseType: "blob" });

// Quick Message Categories
export const getQuickMessageCategories = () => api.get("/quick-message-categories");
export const createQuickMessageCategory = (data) => api.post("/quick-message-categories", data);
export const updateQuickMessageCategory = (id, data) => api.put(`/quick-message-categories/${id}`, data);
export const deleteQuickMessageCategory = (id) => api.delete(`/quick-message-categories/${id}`);

// Contact Import/Export
export const importContacts = (contacts) => api.post("/contacts/import", { contacts });
export const exportContacts = () => api.get("/contacts/export", { responseType: "blob" });

// Agent Performance
export const getAgentPerformance = (params) => api.get("/agent-performance", { params });

// BBB Meetings
export const createBBBMeeting = (data) => api.post("/bbb/meetings", data);
export const joinBBBMeeting = (data) => api.post("/bbb/join", data);
export const listBBBMeetings = () => api.get("/bbb/meetings");
export const getBBBMeetingHistory = (params) => api.get("/bbb/meetings/history", { params });
export const endBBBMeeting = (meetingID) => api.delete(`/bbb/meetings/${meetingID}`);